import axios from "axios";
import { BASE_API_URL } from "../utils/api-url";
import { redirect } from "react-router-dom";

export const getVolumeByZone = async (accessToken, zones, dateFrom, dateTo) => {
  try {
    const result = await axios({
      method: "POST",
      url: `${BASE_API_URL}/chart/zones`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data: {
        zones,
        dateTo,
        dateFrom,
      },
    });

    if (result.data === "Unauthorized") {
      alert("Token inválido, faça login novamente.");
      redirect("/");
    }

    return result;
  } catch (error) {
    alert("Desculpe, algo deu errado.");
  }
};

export const getVolumeByCity = async (
  accessToken,
  cities,
  dateFrom,
  dateTo
) => {
  try {
    const result = await axios({
      method: "POST",
      url: `${BASE_API_URL}/chart/cities`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data: {
        cidades: cities,
        dateTo,
        dateFrom,
      },
    });

    if (result.data === "Unauthorized") {
      alert("Token inválido, faça login novamente.");
      redirect("/");
    }

    return result;
  } catch (error) {
    alert("Desculpe, algo deu errado.");
  }
};

export const getVolumeByCompany = async (accessToken, dateFrom, dateTo) => {
  try {
    const result = await axios({
      method: "POST",
      url: `${BASE_API_URL}/chart/companies`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data: {
        dateTo,
        dateFrom,
      },
    });

    if (result.data === "Unauthorized") {
      alert("Token inválido, faça login novamente.");
      redirect("/");
    }

    if (result.data.companies.length === 0)
      alert("Nenhum resultado encontrado para esse período.");

    return result;
  } catch (error) {
    if (
      error.response.data ===
      "Ops: não encontramos dados com as informações passadas"
    ) {
      return alert(
        error.response.data || "Não encontramos dados com essas informações."
      );
    }
    return alert("Desculpe, algo deu errado.");
  }
};

export const getVolumeByProduct = async (
  accessToken,
  product,
  dateFrom,
  dateTo
) => {
  try {
    const result = await axios({
      method: "POST",
      url: `${BASE_API_URL}/chart/produto`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data: {
        idProduto: product,
        dateTo,
        dateFrom,
      },
    });

    if (result.data === "Unauthorized") {
      alert("Token inválido, faça login novamente.");
      redirect("/");
    }

    return result;
  } catch (error) {
    if (
      error.response.data ===
      "Ops: não encontramos dados com as informações passadas"
    ) {
      return alert(
        error.response.data || "Não encontramos dados com essas informações."
      );
    }
    return alert("Desculpe, algo deu errado.");
  }
};

export const getVolumeByCovep = async (
  accessToken,
  dateFrom,
  dateTo,
  motivo,
  subMotivo
) => {
  try {
    const result = await axios({
      method: "POST",
      url: `${BASE_API_URL}/chart/motivo`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data: {
        motivo,
        subMotivo,
        dateTo,
        dateFrom,
      },
    });

    if (result.data === "Unauthorized") {
      alert("Token inválido, faça login novamente.");
      redirect("/");
    }

    return result;
  } catch (error) {
    if (
      error.response.data ===
      "Ops: não encontramos dados com as informações passadas"
    ) {
      return alert(
        error.response.data || "Não encontramos dados com essas informações."
      );
    }
    return alert("Desculpe, algo deu errado.");
  }
};

export const getVolumeByCompetitor = async (
  accessToken,
  dateFrom,
  dateTo,
  idsCompetidor
) => {
  try {
    const result = await axios({
      method: "POST",
      url: `${BASE_API_URL}/chart/concorrente`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data: {
        dateFrom,
        dateTo,
        idsCompetidor,
      },
    });

    if (result.data === "Unauthorized") {
      alert("Token inválido, faça login novamente.");
      redirect("/");
    }

    return result;
  } catch (error) {
    if (
      error.response.data ===
      "Ops: não encontramos dados com as informações passadas"
    ) {
      return alert(
        error.response.data || "Não encontramos dados com essas informações."
      );
    }
    return alert("Desculpe, algo deu errado.");
  }
};

export const getVolumeByUsuario = async (
  accessToken,
  dateFrom,
  dateTo,
  userId
) => {
  try {
    const result = await axios({
      method: "POST",
      url: `${BASE_API_URL}/chart/user`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data: {
        dateFrom,
        dateTo,
        userId,
      },
    });

    if (result.data === "Unauthorized") {
      alert("Token inválido, faça login novamente.");
      redirect("/");
    }

    return result;
  } catch (error) {
    if (
      error.response.data ===
      "Ops: não encontramos dados com as informações passadas"
    ) {
      return alert(
        error.response.data || "Não encontramos dados com essas informações."
      );
    }
    return alert("Desculpe, algo deu errado.");
  }
};
